module.exports = __webpack_public_path__ + "img/rohy.deefa5e4.svg";